import { useAnalytics } from '@medely/ui-kit';
import { useCurrentUser } from '../useCurrentUser';
import { useOTAMetadata } from '../useOTAMetadata';

export function useOnboardingVideoEvent() {
  const analytics = useAnalytics();
  const { currentUser } = useCurrentUser();
  const accountId = currentUser?.professional?.id;
  const otaMetadata = useOTAMetadata();

  const trackModalOpened = ({ platform }: { platform: 'web' | 'mobile' }) => {
    analytics.track('Onboarding - Educational Video - Rendered', {
      context: 'Onboarding',
      subcontext: 'Educational Video',
      action: 'Rendered',
      account_id: accountId,
      platform,
      ...otaMetadata,
    });
  };

  const trackModalClosed = ({ platform }: { platform: 'web' | 'mobile' }) => {
    analytics.track('Onboarding - Educational Video - Closed', {
      context: 'Onboarding',
      subcontext: 'Educational Video',
      action: 'Closed',
      account_id: accountId,
      platform,
      ...otaMetadata,
    });
  };

  const trackLearnMore = ({ platform }: { platform: 'web' | 'mobile' }) => {
    analytics.track('Onboarding - Learn More Button - Clicked', {
      context: 'Onboarding',
      subcontext: 'Learn More Button',
      action: 'Clicked',
      account_id: accountId,
      platform,
      ...otaMetadata,
    });
  };

  return { trackModalOpened, trackModalClosed, trackLearnMore };
}
